import React from 'react';
import {Col, Menu, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {EditOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useTableMenuContext} from "../../../list/components/TableMenu";
import {font_icon} from "../../../column";

const DG_Menu_Update_Link = ({hint, ...props}) => {

    const {t} = useTranslation()
    const {mode} = useTableMenuContext()

    return (

        <>
            {mode === "setting" ?
                <Col>
                    <Tooltip title={t("tnp.button.update") || hint}>
                        <Link {...props.link}>

                            <EditOutlined className={"text-lg text-[#344054] absolute top-1/2 cursor-pointer"}
                                          style={{transform: "translateY(-50%)",fontSize : font_icon}}/>
                        </Link>
                    </Tooltip>
                </Col>
                :
                <Menu.Item {...props} icon={props.icon ? props.icon :
                    <EditOutlined className={props?.iconClassName}
                                  title={props?.title ? props?.title : t("tnp.button.update")}
                    style={{fontSize: font_icon}}/>}>
                    <Link {...props.link}>
                        {props.title ? props.title : t("common.update")}
                    </Link>
                </Menu.Item>
            }
        </>
    );
};


DG_Menu_Update_Link.propTypes = {};

export default DG_Menu_Update_Link;
